import { type ReactElement, createContext, useContext } from 'react';

export enum SnoozeTab {
    ACTIVE = 'active',
    SNOOZED = 'snoozed',
}

// Per-view snooze state for a snoozable container's table, supplied by SnoozeTabbedTable.
export type SnoozeContextValue = {
    // Active/Snoozed tab strip, rendered under the table title by ContainerTableWrapper.
    tabs: ReactElement;
    // The container's queue key (= container.key); the snooze scope sent as
    // `containerKey` to the mutation and matched in the count/list filters.
    queueKey: string;
    // Selected tab.
    tab: SnoozeTab;
};

const SnoozeContext = createContext<SnoozeContextValue | null>(null);

export const SnoozeProvider = SnoozeContext.Provider;

export const useSnoozeContext = (): SnoozeContextValue | null => useContext(SnoozeContext);
